<script>
/* Imports */
import { mapGetters } from 'vuex';

export default {
  name: 'Titles',
  props: {
    title: {
      type: String,
      default: '',
    },
    showProductName: {
      type: Boolean,
      default: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    showSubtitle: {
      type: Boolean,
      default: true,
    },
    partNumber: {
      type: String,
      default: '',
    },
    showPartNumber: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      partNumberTitle: 'getPartNumberTitle',
    }),
  },
};
</script>

<template>
  <div id="js__product__meta">
    <g-heading
      v-if="showProductName"
      id="js__product__info__name"
      class="app__product__info__title"
      text-align="left"
    >
      <h1 v-html="title" />
    </g-heading>
    <p
      v-if="showSubtitle"
      id="js__product__info__variation"
      class="app__product__info__subtitle"
      v-html="subtitle"
    />
    <p
      v-if="showPartNumber"
      id="js__product__info__part-number"
      class="app__product__info__part-number"
    >
      <span
        id="js__product__info__part-number__label"
        v-html="partNumberTitle"
      />
      <span
        id="js__product__info__part-number__text"
        class="app__product__info__part-number--light"
      >
        {{ partNumber }}
      </span>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.app__product {
  position: relative;
  display: flex;
  flex-flow: row wrap;

  &__info {

    &__title {

      :deep(h1) {
        margin: 0;
      }
    }

    &__subtitle {
      font-size: 1.11em;
      line-height: 2rem;
      @include font-primary-weight-regular();
      color: $color-black;
      margin: 0 auto 0.5em;

      @include productBreakpoint('desktop-s') {
        margin-left: 0;
        margin-right: 0;
      }
    }

    &__part-number {
      font-size: 0.7em;
      font-weight: 700;
      text-transform: uppercase;
      color: $color-black;
      margin: 1em 0;

      &--light {
        padding-left: 0.2rem;
        font-weight: 500;
      }
    }
  }
}
</style>
